import { __assign, __rest } from "tslib";
import React, { Fragment, useEffect, useMemo, useState } from 'react';
import InputField from '../_components/InputField';
import FormContainer from './FormContainer';
import formSchema from '../form.schema';
import useFormUpdate from '../hooks/useFormUpdate';
import FormItemWrapper from './FormItemWrapper';
import useInitialState from '../hooks/useInitialState';
import { parseInitialValue } from '../helpers/utils';
function FormWrapper(_a) {
    var formId = _a.formId, inputFields = _a.inputFields, buttonProps = _a.buttonProps, error = _a.error, onSubmitCb = _a.onSubmitCb, onUpdate = _a.onUpdate, children = _a.children, _b = _a.followInitialState, followInitialState = _b === void 0 ? false : _b, props = __rest(_a, ["formId", "inputFields", "buttonProps", "error", "onSubmitCb", "onUpdate", "children", "followInitialState"]);
    var _c = useState(formId), currentFormId = _c[0], setCurrentFormId = _c[1];
    var availableInputFields = inputFields.filter(function (i) { return !i.isHidden; });
    var _d = formSchema(availableInputFields), initialState = _d.initialState, validationStateSchema = _d.validationStateSchema;
    var formUpdate = useFormUpdate(initialState, validationStateSchema, onSubmitCb);
    var formData = formUpdate.formData, updatedData = formUpdate.updatedData, handleUpdateData = formUpdate.handleUpdateData, handleOnSubmit = formUpdate.handleOnSubmit, isLoading = formUpdate.isLoading, isEnabled = formUpdate.isEnabled, resetData = formUpdate.resetData;
    useInitialState(initialState, resetData, { paused: !followInitialState });
    var isButtonDisabled = useMemo(function () {
        // the parent can configure extra isDisabled conditions if it includes isDisabled with additional logginc
        if (buttonProps && 'isDisabled' in buttonProps) {
            return !isEnabled || buttonProps.isDisabled;
        }
        else {
            return !isEnabled;
        }
    }, [buttonProps, isEnabled]);
    useEffect(function () {
        if (currentFormId === formId) {
            onUpdate && onUpdate({
                formId: formId,
                updatedData: updatedData,
                isEnabled: isEnabled
            });
        }
        else {
            resetData();
            setCurrentFormId(formId);
        }
    }, [onUpdate, updatedData, isEnabled, formId, currentFormId]);
    return (React.createElement(FormContainer, __assign({ buttonProps: __assign(__assign({}, buttonProps), { isLoading: isLoading, isDisabled: isButtonDisabled, onClick: handleOnSubmit }) }, { error: error }, props),
        availableInputFields.map(function (props) {
            delete props.isHidden;
            return (React.createElement(Fragment, { key: props.name.toString() }, (function () {
                var _a, _b, _c, _d;
                switch (props.componentType) {
                    case 'input': {
                        var componentType = props.componentType, initialValue = props.initialValue, name_1 = props.name, validation = props.validation, value = props.value, onValueChange_1 = props.onValueChange, restOfProps = __rest(props
                        // if a value is passed, this will update its state within useFormUpdate hook
                        , ["componentType", "initialValue", "name", "validation", "value", "onValueChange"]);
                        // if a value is passed, this will update its state within useFormUpdate hook
                        if (typeof value === 'string' && ((_a = formData[name_1]) === null || _a === void 0 ? void 0 : _a.value) !== value) {
                            handleUpdateData({ id: restOfProps.id, name: name_1, value: value }).then();
                        }
                        return (React.createElement(InputField, __assign({ isRequired: validation === null || validation === void 0 ? void 0 : validation.required, value: parseInitialValue((_b = formData[name_1]) === null || _b === void 0 ? void 0 : _b.value), error: (_c = formData[name_1]) === null || _c === void 0 ? void 0 : _c.error }, restOfProps, { onValueChange: function (payload) {
                                onValueChange_1 && onValueChange_1(payload);
                                handleUpdateData(payload).then();
                            } }, { name: name_1 })));
                    }
                    case 'component': {
                        var name_2 = props.name, validation = props.validation, label = props.label, helperText = props.helperText, error_1 = props.error, noTopSpace = props.noTopSpace, component = props.component, initialValue = props.initialValue;
                        var clonedComponentProps = {
                            defaultValue: initialValue,
                            value: (_d = formData[name_2]) === null || _d === void 0 ? void 0 : _d.value,
                            onUpdateValue: function (value) {
                                return handleUpdateData({
                                    id: name_2,
                                    name: name_2,
                                    value: value
                                });
                            }
                        };
                        return (React.createElement(FormItemWrapper, __assign({ isRequired: validation === null || validation === void 0 ? void 0 : validation.required }, {
                            name: name_2,
                            label: label,
                            helperText: helperText,
                            error: error_1,
                            noTopSpace: noTopSpace
                        }), React.cloneElement(component, clonedComponentProps)));
                    }
                    default:
                        return props;
                }
            })()));
        }),
        children));
}
export default FormWrapper;
//# sourceMappingURL=FormWrapper.js.map